<template>
  <div class="calendar">
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-calendar-month</v-icon>
        <h1 class="page-title">Calendar</h1>
      </v-layout>
    </div>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn outlined class="mr-4" @click="setToday"> Today </v-btn>
            <v-btn fab text small @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn fab text small @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            color="secondary"
            ref="calendar"
            v-model="focus"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card min-width="350px" outlined :class="getEventClass(selectedEvent)">
              <v-row>
                <v-col cols="12">
                  <h2 :class="getEventClass(selectedEvent)">
                    {{ selectedEvent.name }}
                  </h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h3 :class="getEventClass(selectedEvent)" v-html="selectedEvent.details">
                  </h3>
                </v-col>
              </v-row>
              <v-row v-if="priviledgedEvent">
                <v-col cols="12">
                  <v-btn
                    :class="getEventClass(selectedEvent)"
                    outlined
                    @click="onEditEvent(selectedEvent.id)"
                  >
                    <v-icon left>mdi-pencil</v-icon>Edit
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    :class="getEventClass(selectedEvent)"
                    outlined
                    @click="selectedOpen = false"
                  >
                    <v-icon left>mdi-close</v-icon>Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <!-- <v-card min-width="350px" flat :color="selectedEvent.color">
              <v-toolbar :color="selectedEvent.color">
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              </v-toolbar>
              <v-card-text :class="getTextColor(selectedEvent)">
                <span v-html="selectedEvent.details"></span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <div v-if="priviledgedEvent" class="button">
                  <v-btn
                    outlined
                    @click="onEditEvent(selectedEvent.id)"
                  >
                    <v-icon left>mdi-pencil</v-icon>Edit
                  </v-btn>
                </div>
                <div v-if="priviledgedEvent" class="button">
                  <v-btn
                    class="button"
                    outlined
                    @click="onDeleteEvent(selectedEvent.id)"
                  >
                    <v-icon left>mdi-delete</v-icon>Delete
                  </v-btn>
                </div>
                <div class="button">
                  <v-btn
                    outlined
                    @click="selectedOpen = false"
                  >
                    <v-icon left>mdi-close</v-icon>Close
                  </v-btn>
                </div>
                <div class="button">
                  <v-btn
                    class="button"
                    text
                    outlined
                    @click="onSignup(selectedEvent)"
                    v-if="
                      canSignup(
                        selectedEvent.signupStart,
                        selectedEvent.signupEnd
                      )
                    "
                  >
                    <v-icon left>mdi-login-variant</v-icon>Signup
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card> -->
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn v-if="priviledged" outlined @click="onAddEvent">
        <v-icon left>mdi-plus</v-icon>Add Event
      </v-btn>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"
            >Delete the selected<br />calendar event?</v-card-title
          >
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">No</v-btn>
            <v-btn text @click="deleteEvent">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/calendar"></statusalert>
  </div>
</template>

<script>
import CalendarEventsService from '../../services/api/CalendarEventsService.js'
import EventsService from '../../services/api/EventsService'
import store from '@/store/index.js'
import moment from 'moment'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Calendar',
  components: {
    statusalert
  },
  store: store,

  data: () => ({
    dialog: false,
    calendarEventId: 0,
    title: '',
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      'red',
      'green',
      'blue',
      'red darken-4',
      'green darken-4',
      'blue darken-4',
      'orange',
      'grey darken-2'
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party'
    ]
  }),
  mounted() {
    this.$refs.calendar.checkChange()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    },
    priviledgedEvent() {
      return (
        (this.$store.getters.getAdministrator ||
          this.$store.getters.getProShop) &&
        this.selectedEvent.type === 'Event'
      )
    }
  },
  methods: {
    onAddEvent() {
      router.push('/calendar/edit/0')
    },

    onEditEvent(id) {
      router.push('/calendar/edit/' + id)
    },

    onDeleteEvent(id) {
      this.dialog = true
      const event = this.events.find(e => e.id === id)
      this.title = ''
      if (event) {
        this.calendarEventId = event.id
        this.title = event.name
      }
    },

    deleteEvent() {
      this.dialog = false
      if (this.calendarEventId > 0) {
        store.commit('isLoading')
        CalendarEventsService.delete(this.calendarEventId)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Calendar event deleted']
            }
            const index = this.events.findIndex(
              e => e.id === this.calendarEventId
            )
            this.events.splice(index, 1)
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to delete Calendar event']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.$refs.alert.displayResult(this.result)
          })
      }
    },

    getColor(id) {
      return this.colors[id]
    },
    getEventColor(event) {
      return event.color
    },
    getEventClass(event) {
      console.log(event.color)
      let x = ''
      if (store.getters.getDark) {
        x = 'd-'
      } else {
        x = 'l-'
      }
      switch (event.color) {
        case 'red darken-4':
          x = x + 'darkred'
          break

        case 'green darken-4':
          x = x + 'darkgreen'
          break

        case 'blue darken-4':
          x = x + 'darkblue'
          break

        case 'grey darken-2':
          x = x + 'grey'
          break

        default:
          x = x + event.color
      }
      return x
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => (this.selectedOpen = true), 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    canSignup(startDate, endDate) {
      return EventsService.canSignup(startDate, endDate)
    },

    onSignup(event) {
      router.push('/schedule/pay/' + event.id)
    },

    updateRange({ start, end }) {
      const data = []
      CalendarEventsService.get(start.date, end.date)
        .then(events => {
          for (var i = 0; i < events.length; i++) {
            let signupStart = null
            let signupEnd = null
            var evt = events[i]
            var params = evt.url.split('#')
            const type = params[0]
            const dtStart = moment(evt.startDate).format('YYYY-MM-DD hh:mm')
            const dtEnd = moment(evt.endDate).format('YYYY-MM-DD hh:mm')
            var details = evt.description
            var title = evt.title
            if (type === 'Signup') {
              title = evt.title + ' Signup'
              const dtTournamentStart = moment(params[1]).format(
                'YYYY-MM-DD hh:mm'
              )
              const dtTournamentEnd = moment(params[2]).format(
                'YYYY-MM-DD hh:mm'
              )
              signupStart = dtStart
              signupEnd = dtEnd
              details =
                '<strong>Signup</strong><br><div class="indent">Begins: ' +
                dtStart +
                '</div><div class="indent">Ends: ' +
                dtEnd +
                ' or when the tournament is full.</div><br>' +
                '<strong>Tournament</strong>' +
                '<br><div class="indent">Start: ' +
                dtTournamentStart +
                '</div><div class="indent">End: ' +
                dtTournamentEnd +
                '</div><br>' +
                evt.description
            } else if (type === 'Tournament') {
              signupStart = moment(params[1]).format('YYYY-MM-DD hh:mm')
              signupEnd = moment(params[2]).format('YYYY-MM-DD hh:mm')
              details =
                '<strong>Signup</strong><br><div class="indent">Begins: ' +
                signupStart +
                '</div><div class="indent">Ends: ' +
                signupEnd +
                ' or when the tournament is full.</div><br>' +
                '<strong>Tournament</strong>' +
                '<div class="indent>Start: ' +
                dtStart +
                '</div><div class="indent">End: ' +
                dtEnd +
                '</div><br>' +
                evt.description
            }
            data.push({
              id: evt.calendarEventId,
              name: title,
              details: details,
              start: dtStart,
              end: dtEnd,
              signupStart: signupStart,
              signupEnd: signupEnd,
              color: this.getColor(evt.eventColorId),
              timed: false,
              type: type
            })
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
      this.events = data
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  margin-right: 30px;
}
.calendar-view {
  width: 50px;
}
.indent {
  margin-left: 20px;
  margin-right: 10px;
}
.d-green {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #4caf50 !important;
}
.l-green {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #4caf50 !important;
}
.d-blue {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #2196f3 !important;
}
.l-blue {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #2196f3 !important;
}
.d-red {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #f44336 !important;
}
.l-red {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #f44336 !important;
}
.d-darkred {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #b71c1c !important;
}
.l-darkred {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #b71c1c !important;
}
.d-darkgreen {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #1b5e20 !important;
}
.l-darkgreen {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #1b5e20 !important;
}
.d-darkblue {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #0d47a1 !important;
}
.l-darkblue {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #0d47a1 !important;
}
.d-orange {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #ff9800 !important;
}
.l-orange {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #ff9800 !important;
}
.d-grey {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #616161 !important;
}
.l-grey {
  margin-left: 10px;
  margin-right: 10px;
  color: white !important;
  background-color: #616161 !important;
}
</style>
